import React from "react";
import styled from "styled-components";

// Imported assets
// import CloseIcon from "../../../assets/icons/close.svg";
import WarningIcon from "../../../../assets/icons/warning-triangle.svg";

// Imported components
import PrimaryButton from "../../../../components/ui/PrimaryButton";

// Styled components
const ButtonGroup = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  gap: 12px;
  justify-content: space-between;
  position: relative;
  margin-top: 16px;
`;

const CancelButton = styled(PrimaryButton)`
  background: white;
  border: 1px solid #d9d9d9;
  color: black;

  &:hover {
    background: lab(from white calc(l - 5) a b / 100);
  }
`;

// const CloseButton = styled.img`
//   background-color: transparent;
//   border: none;
//   font-size: 16px;
//   cursor: pointer;
//   color: #333;
//   position: absolute;
//   margin: 10px;
//   right: 0px;
//   top: 0px;
//   width: 50px;
//   z-index: 120;
// `;

const ConfirmButton = styled(PrimaryButton)`
  background: var(--terbine-blue);
  color: white;

  &:hover {
    background: lab(from var(--terbine-blue) calc(l - 5) a b / 100);
  }
`;

const Form = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  position: relative;
`;

const FormHeader = styled.h2`
  font-family: Oxygen, Inter, Roboto, sans-serif;
`;

const FormSubtitle = styled.h5`
  font-family: Inter, Oxygen, Roboto, sans-serif;
`;

interface ModalProps {
  $isOpen?: boolean;
}

const Modal = styled.div<ModalProps>`
  background-color: white;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  display: ${({ $isOpen }) => ($isOpen ? "flex" : "none")};
  flex-direction: column;
  left: 50%;
  max-width: 80%;
  min-width: 700px;
  overflow-y: auto;
  padding: 20px 40px;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 110;
`;

interface OverlayProps {
  $isOpen?: boolean;
}

const Overlay = styled.div<OverlayProps>`
  background-color: rgba(0, 0, 0, 0.5);
  display: ${({ $isOpen }) => ($isOpen ? "block" : "none")};
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 109;
`;

const WarningBox = styled.div`
  background: #f5d7d7;
  border-left: 5px solid #720d00;
  font-family: Inter, Oxygen, Roboto, sans-serif !important;
  padding: 10px 20px;

  & * {
    font-family: Inter, Oxygen, Roboto, sans-serif !important;
  }
`;

const WarningBoxHeader = styled.div`
  color: #771505;
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
`;

const WarningBoxHeaderIcon = styled.img`
  background-color: transparent;
  border: none;
  color: #771505;
  font-size: 16px;
  width: 20px;
`;

const WarningBoxHeaderText = styled.b`
  margin-right: 5px;
`;

const WarningBoxMessage = styled.div`
  color: #b42600;
`;

const NewContactModal = ({
  configToDelete,
  handleDelete,
  isConfirmDeleteModalOpen,
  toggleDeleteModal,
}) => {
  // Toggle modal open state based on current state
  const toggleModal = () => {
    toggleDeleteModal(!isConfirmDeleteModalOpen);
  };

  const toggleDelete = () => {
    handleDelete(configToDelete.id);
    toggleModal();
  };

  return (
    <div>
      <Overlay $isOpen={isConfirmDeleteModalOpen} onClick={toggleModal} />

      <Modal $isOpen={isConfirmDeleteModalOpen} id="modal">
        {/* <CloseButton onClick={toggleModal} src={CloseIcon} /> */}

        <Form>
          <FormHeader>Delete Notification</FormHeader>
          <FormSubtitle>
            Are you sure you want to delete <b>{configToDelete?.name}</b>?
          </FormSubtitle>
          <WarningBox>
            <WarningBoxHeader>
              <WarningBoxHeaderText>Warning</WarningBoxHeaderText>
              <WarningBoxHeaderIcon src={WarningIcon}></WarningBoxHeaderIcon>
            </WarningBoxHeader>
            <WarningBoxMessage>
              By deleting this notification, you won't be notified if an event
              occurs at this station.
            </WarningBoxMessage>
          </WarningBox>
          <ButtonGroup>
            <CancelButton onClick={toggleModal} type="button">
              No, Cancel
            </CancelButton>
            <ConfirmButton onClick={toggleDelete} type="button">
              Yes, Delete
            </ConfirmButton>
          </ButtonGroup>
        </Form>
      </Modal>
    </div>
  );
};

export default NewContactModal;
